import React, { useCallback, useImperativeHandle, useRef, useState } from "react";
import { isEqual, isFunction } from "@util/utils";
import EditMemoDialog from "./EditMemoDialog";
import useMessageDialog from "@util/hook/useMessageDialog";

const EDIT_MEMO_DIALOG = "EditMemoDialog";

const CreateOrderDialogBox = React.forwardRef((props, ref) => {
	const [openDialog, setOpenDialog] = useState("");
	const [sourceData, setSourceData] = useState(null);
	const refreshRef = useRef(null);
	const setMessageDialog = useMessageDialog();

	const handleDialogClose = useCallback(
		() => {
			setOpenDialog(null);
			setSourceData(null);
		},
		// eslint-disable-next-line
		[],
	);

	const doRefresh = (...arg) => {
		if (isFunction(refreshRef.current)) {
			setTimeout(() => refreshRef.current(...arg), 5);
		}
	};

	useImperativeHandle(
		ref,
		() => ({
			// 開啟編輯備註彈窗
			openEditMemoDialog: (targetData, refreshFn) => {
				refreshRef.current = refreshFn;
				setSourceData(targetData);
				setOpenDialog(EDIT_MEMO_DIALOG);
			},
			// 開啟商品選擇彈窗
			openConfirmDeleteItemDialog: (_, refreshFn) => {
				setMessageDialog({
					open: true,
					title: "確認刪除",
					msg: "要刪除這一筆項目嗎？刪除後無法復原喔。",
					onAsyncConfirm: (_, onClose) => {
						isFunction(refreshFn) && refreshFn();
						onClose();
					},
				});
			},
			// 關閉彈窗
			closeDialog: () => {
				handleDialogClose();
			},
		}),
		// eslint-disable-next-line
		[],
	);

	return (
		<React.Fragment>
			<EditMemoDialog open={isEqual(openDialog, EDIT_MEMO_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
		</React.Fragment>
	);
});

export default CreateOrderDialogBox;
